export const BranchEventNames = {
  ADD_TO_CART: 'ADD_TO_CART',
  COMPLETE_REGISTRATION: 'COMPLETE_REGISTRATION',
  LOGIN: 'LOGIN',
  PURCHASE: 'PURCHASE',
};
